<div class="academy-shell">
  <section class="hero">
    <div class="hero-content">
      <p class="hero-eyebrow">AI Code Academy</p>
      <h1>Dynamic coding, HTML, CSS, and JavaScript — all in one quest.</h1>
      <p class="hero-subtitle">
        Four learning tracks, 15 new solutions, live typing demos, and a Gemini tutor
        that adapts to your pace.
      </p>
      <div class="hero-actions">
        <button type="button" class="glow-btn" (click)="regenerateDataset()">Shuffle Dataset</button>
        <div class="hero-badge">Multi-track AI catalog styling</div>
      </div>
    </div>
  </section>

  <section class="patterns">
    <div class="tab-group-card">
      <p class="tab-title">Course Categories</p>
      <div class="pattern-tabs">
        <button
          *ngFor="let category of categories; let i = index"
          type="button"
          class="pattern-tab"
          [class.active]="i === activeCategoryIndex"
          (click)="setActiveCategory(i)"
        >
          {{ category.title }}
        </button>
      </div>
      <p class="tab-description">{{ activeCategory.description }}</p>
    </div>

    <div class="tab-group-card">
      <p class="tab-title">Skill Tracks</p>
      <div class="pattern-tabs">
        <button
          *ngFor="let level of activeCategory.levels; let i = index"
          type="button"
          class="pattern-tab"
          [class.active]="i === activeLevelIndex"
          (click)="setActiveLevel(i)"
        >
          {{ level.title }}
        </button>
      </div>
      <p class="tab-description">{{ activeLevel.subtitle }}</p>
    </div>

    <div class="tab-group-card">
      <p class="tab-title">Lesson Tabs</p>
      <div class="pattern-tabs">
        <button
          *ngFor="let lesson of activeLevel.lessons; let i = index"
          type="button"
          class="pattern-tab"
          [class.active]="i === activeLessonIndex"
          (click)="setActiveLesson(i)"
        >
          {{ lesson.title }}
        </button>
      </div>
    </div>

    <div class="pattern-detail">
      <div class="pattern-card">
        <div class="pattern-header">
          <div class="track-meta">
            <span class="track-pill">{{ activeCategory.title }}</span>
            <span class="track-pill">{{ activeLevel.title }}</span>
          </div>
          <h2>{{ activeLesson.title }}</h2>
          <p class="pattern-intro">{{ activeLesson.intro }}</p>
        </div>

        <div class="pattern-grid">
          <div class="pattern-block">
            <h3>Concept</h3>
            <p>{{ activeLesson.logic }}</p>
          </div>
          <div class="pattern-block code-block">
            <h3>Code Example</h3>
            <pre><code>{{ activeLesson.code }}</code></pre>
          </div>
        </div>

        <div class="pattern-task">
          <div class="task-column">
            <h3>Problem</h3>
            <p>{{ activeLesson.problem }}</p>
          </div>
          <div class="task-column">
            <h3>Task</h3>
            <p>{{ activeLesson.task }}</p>
          </div>
          <div class="task-column dataset">
            <h3>Starter dataset</h3>
            <pre>{{ activeDataset }}</pre>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="demo">
    <div class="demo-screen">
      <div class="demo-header">Live Typing Demo</div>
      <pre class="demo-body">{{ typedDemo }}<span class="cursor" [class.idle]="!isTyping">█</span></pre>
    </div>
  </section>

  <section class="tips">
    <div class="tips-header">
      <h3>Need a nudge?</h3>
      <p>Hints gently scale up until the light bulb pops on.</p>
    </div>
    <ul class="tips-list">
      <li *ngFor="let tip of visibleTips">{{ tip }}</li>
    </ul>
    <button type="button" class="ghost-btn" (click)="revealTip()" [disabled]="allTipsRevealed">
      {{ allTipsRevealed ? 'All tips revealed' : 'Show another tip' }}
    </button>
  </section>

  <section class="coding-pad">
    <div class="pad-header">
      <div>
        <h3>CodePad</h3>
        <p>Drop your solution and get tailored Gemini feedback.</p>
      </div>
      <div class="pad-controls">
        <label>
          Skill level
          <select [(ngModel)]="skillLevel">
            <option>Beginner</option>
            <option>Intermediate</option>
            <option>Advanced</option>
          </select>
        </label>
        <label class="passion-control">
          Passion level
          <input type="range" min="1" max="5" step="1" [(ngModel)]="passionLevel" />
          <span>{{ passionLevel }}/5</span>
        </label>
      </div>
    </div>

    <textarea
      class="code-input"
      [(ngModel)]="userSolution"
      rows="10"
      placeholder="Write your solution (or pseudocode) here..."
    ></textarea>

    <button
      type="button"
      class="glow-btn submit-btn"
      (click)="submitSolution()"
      [disabled]="isSubmitting || !userSolution.trim()"
    >
      {{ isSubmitting ? 'Sending to Gemini tutor...' : 'Submit solution' }}
    </button>
  </section>

  <section class="messages-container">
    <div
      class="message"
      *ngFor="let message of messages"
      [ngClass]="{ 'user-message': message.role === 'user', 'assistant-message': message.role === 'assistant' }"
    >
      <div
        class="markdown prism-content"
        [innerHTML]="convertMarkdown(message.content)"
      ></div>
    </div>
  </section>
</div>